import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { PATHNAMES } from "src/constants/routes";
import { IChat } from "src/@types/chat";

export const CHAT_SLICE_NAME = "chat";

interface Params {
  id: string;
}

export const getChatAsync = createAsyncThunk(
  `${CHAT_SLICE_NAME}/fetchChat`,
  async ({ id }: Params, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IChat>(`/chats/${id}/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.HOME, { replace: true });

      NotificationService.error(errorText || errorResponsesTrns.gettingChat);

      return rejectWithValue(errorText);
    }
  }
);
